import { SummaryComponent } from './home-page/sales-forecast/summary.component';
import { UserComponent } from './home-page/user/user.component';
import { StoreViewComponent } from './home-page/store-view/store-view.component';
import { LayoutsComponent } from './components/layouts/layouts.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { PagesPage404 } from './login/page-404.page';
import { ForgetPasswordComponent } from './login/forget-password.component';
import { ConfirmPasswordComponent } from './login/confirm-password.component';
import { ResetPasswordReq } from './login/resetPasswordreq.page';
import { AuthGuard } from './login/AuthGuard/auth.guard';
import { RoleGuard } from './login/AuthGuard/role.guard';


export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '', component: LayoutsComponent, children: [
      { path: 'login', component: LoginComponent },
      { path: 'page-404', component: PagesPage404 },
      { path: 'forget', component: ForgetPasswordComponent },
      { path: 'resetpassword', component: ConfirmPasswordComponent },
      { path: 'resetpasswordreq', component: ResetPasswordReq },
      { path: 'user', component: UserComponent, canActivate: [AuthGuard] },
      { path: 'Home', component: SummaryComponent, canActivate: [AuthGuard] },
      { path: 'Map', component: StoreViewComponent, canActivate: [AuthGuard] },

      { path: '**', redirectTo: 'page-404', pathMatch: 'full' }
    ]
  },
  // { path: 'dashboards-beta', component: DashboardsBeta, canActivate: [AuthGuard] },
  // { path: 'dashboards-alpha', component: DashboardsAlpha, canActivate: [RoleGuard], data: { expectedRole: 'admin'}},
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts